import {
  ArrowLeftRight,
  BanknoteArrowUp,
  Building2,
  ChartColumnIncreasing,
  ChartPie,
  CircleGauge,
  CreditCard,
  Landmark,
  List,
  ReceiptText,
} from 'lucide-react';
import { exhaustiveCheck } from '../../../utils/exhaustive-check';
import { SideNavItem } from '../components/side-nav';

export const getNavItemContent = (variant: SideNavItem) => {
  switch (variant) {
    case 'DASHBOARD':
      return {
        icon: CircleGauge,
        label: 'Dashboard',
        linkTo: '/dashboard',
        isBeta: false,
      };
    case 'TRANSACTIONS':
      return {
        icon: List,
        label: 'Transactions',
        linkTo: '/transactions',
        isBeta: false,
      };
    case 'ACCOUNTS':
      return {
        icon: Landmark,
        label: 'Accounts',
        linkTo: '/accounts',
        isBeta: false,
      };
    case 'TREASURY':
      return {
        icon: ChartColumnIncreasing,
        label: 'Treasury',
        linkTo: '/treasury',
        isBeta: true,
      };
    case 'PAYMENTS':
      return {
        icon: ArrowLeftRight,
        label: 'Payments',
        linkTo: '/payments',
        isBeta: false,
      };
    case 'CARDS':
      return {
        icon: CreditCard,
        label: 'Cards',
        linkTo: '/cards',
        isBeta: true,
      };
    case 'INVOICE_PAY':
      return {
        icon: ReceiptText,
        label: 'Invoice Pay',
        linkTo: '/invoice-pay',
        isBeta: false,
      };
    case 'PAYROLLS':
      return {
        icon: BanknoteArrowUp,
        label: 'Payroll',
        linkTo: '/payrolls',
        isBeta: true,
      };
    case 'VENDORS':
      return {
        icon: Building2,
        label: 'Vendors',
        linkTo: '/vendors',
        isBeta: false,
      };
    case 'REPORTING':
      return {
        icon: ChartPie,
        label: 'Reporting',
        linkTo: '/reporting',
        isBeta: false,
      };
    default:
      return exhaustiveCheck(variant);
  }
};
